import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/empty_img.svg'


const _withScopeId = n => (_pushScopeId("data-v-777889b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "title flex between" }
const _hoisted_3 = { class: "title_more" }
const _hoisted_4 = { class: "ellipsis" }
const _hoisted_5 = { class: "lables_box" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "empty"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "lables_box" }
const _hoisted_11 = { class: "time flex between" }
const _hoisted_12 = { class: "flex" }

import { withDefaults } from 'vue';

interface Props {
  component: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MyArticle',
  props: {
    component: { default: Object }
  },
  setup(__props: any) {

const props = __props as { component: any };



return (_ctx: any,_cache: any) => {
  const _component_a_skeleton = _resolveComponent("a-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(props.component.title), 1),
      _withDirectives(_createElementVNode("span", _hoisted_3, "更多>>", 512), [
        [_vShow, props.component.articleList.length > props.component.most]
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["article_list", { list_bg: props.component.style != 3 }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["item_box", { flex: props.component.style == 3 }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.articleList, (item, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({
            style_one: props.component.style == 1,
            style_two: props.component.style == 2,
            style_three: props.component.style == 3,
          }),
            key: index
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({ flex: props.component.style == 2, between: props.component.style == 2 })
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({ info_two: props.component.style == 2 })
              }, [
                _createVNode(_component_a_skeleton, {
                  loading: !item.title,
                  paragraph: { rows: 2 },
                  title: false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["loading"]),
                _withDirectives(_createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.lable, (i, j) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "lables",
                      key: j
                    }, _toDisplayString(i), 1))
                  }), 128))
                ], 512), [
                  [_vShow, props.component.style == 2]
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["imgbox flex between", { img_box: props.component.style == 2 }])
              }, [
                (item.article_kv)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.article_kv,
                      alt: ""
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass({ lables_padding: props.component.style == 3 })
              }, [
                _withDirectives(_createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.lable, (i, j) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "lables",
                      key: j
                    }, _toDisplayString(i), 1))
                  }), 128))
                ], 512), [
                  [_vShow, props.component.style != 2]
                ])
              ], 2)
            ], 2),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_a_skeleton, {
                loading: !item.article_kv,
                paragraph: { rows: 1 },
                title: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.release_time) + " 发布", 1)
                ]),
                _: 2
              }, 1032, ["loading"]),
              _createVNode(_component_a_skeleton, {
                loading: !item.article_kv,
                paragraph: { rows: 1 },
                title: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.browse) + " 浏览", 1)
                ]),
                _: 2
              }, 1032, ["loading"])
            ])
          ], 2)), [
            [_vShow, index + 1 <= props.component.most]
          ])
        }), 128))
      ], 2)
    ], 2)
  ]))
}
}

})